import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

const WrapperCircle = styled(View)`
  margin-left: var(--spacing-0-25);
  margin-right: var(--spacing-0-25);
  margin-top: 9px;
`

const IconCircle = styled(View)`
  width: 7px;
  height: 7px;
  border-radius: 100%;
  background-color: var(--color-neutral-130);
`

const WrapperEmailContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  color: var(--color-neutral-130);
  background-color: var(--color-neutral-80);
  padding: var(--spacing-2);
  margin-bottom: var(--spacing-1);
  border-radius: var(--border-radius-1);
`
const replacePerIcon = email => {
  const newEmail = []
  Array.from(email).forEach(item => {
    if (item === '*') {
      newEmail.push(
        <WrapperCircle>
          <IconCircle />
        </WrapperCircle>
      )
    } else {
      newEmail.push(item)
    }
  })
  return newEmail
}

export const EmailContainer = ({ email }) => (
  <WrapperEmailContainer>{replacePerIcon(email)}</WrapperEmailContainer>
)

EmailContainer.propTypes = {
  email: PropTypes.string.isRequired,
}
